import { createContext, Dispatch, SetStateAction } from 'react';
import { Language } from '../translations';

export type LanguageContextType = {
  language: Language;
  setLanguage: Dispatch<SetStateAction<Language>>;
};

export const LanguageContext = createContext<LanguageContextType>({
  language: 'ru',
  setLanguage: () => {},
});
